module.exports = __webpack_public_path__ + "img/agent-profile.7501390.png";